import { createContext } from 'react';

interface ILoginStatus {
    isLoggedIn: Boolean;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
    loginRefreshRequired: Boolean;
    setLoginRefreshRequired: (loginRefreshRequired: boolean) => void;
}

const defaultState: ILoginStatus = {
  isLoggedIn: false,
  setIsLoggedIn: () => {},
  loginRefreshRequired: false,
  setLoginRefreshRequired: () => {}
}

export const LoginStatusContext = createContext<ILoginStatus>(defaultState);